import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const InvoiceIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g clipPath="url(#invoice-icon_svg__a)">
                <path
                    fill="currentColor"
                    d="m17.3 17.4-.4.8h-5.6l.3-.8h5.7Zm-.8 1.7-.4.8h-4.8l.3-.8h5Zm1.8-4-.4.8-.6-.4-.7-.3H16c-.4 0-.9 0-1.3.3-.3.3-.7.7-.9 1.2-.2.5-.3 1.2-.3 2 0 .7.1 1.3.3 1.8.2.6.6 1 1 1.2.3.3.8.4 1.2.4a2.5 2.5 0 0 0 1.4-.3l.5-.4.4.9a3 3 0 0 1-1 .6l-1.3.2c-.7 0-1.3-.2-1.8-.5-.6-.4-1-1-1.3-1.6-.3-.6-.4-1.4-.4-2.4 0-.9.1-1.7.4-2.4.3-.6.7-1.1 1.3-1.5.5-.4 1.1-.5 1.8-.5a3.4 3.4 0 0 1 2.4.9Z"
                />
                <path
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                    d="M18.5 12.5V7.4a1 1 0 0 0-.3-.7l-2-2a1 1 0 0 0-.7-.2h-10a1 1 0 0 0-1 1v14c0 .6.4 1 1 1h4"
                />
            </g>
            <defs>
                <clipPath id="invoice-icon_svg__a">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    </IconWrapper>
)
